import { render, staticRenderFns } from "./AssignSupervisors.vue?vue&type=template&id=9c101462&scoped=true&"
import script from "./AssignSupervisors.vue?vue&type=script&lang=js&"
export * from "./AssignSupervisors.vue?vue&type=script&lang=js&"
import style0 from "./AssignSupervisors.vue?vue&type=style&index=0&id=9c101462&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c101462",
  null
  
)

export default component.exports